import { render, staticRenderFns } from "./BatchUpdateAppointments.vue?vue&type=template&id=535f5519&"
import script from "./BatchUpdateAppointments.vue?vue&type=script&lang=js&"
export * from "./BatchUpdateAppointments.vue?vue&type=script&lang=js&"
import style0 from "./BatchUpdateAppointments.vue?vue&type=style&index=0&id=535f5519&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports